import React from "react";
import { Link } from 'react-router-dom';
import './Footer.css';
import kliqon from '../../assets/logo/kliqon.jpg'

const Footer = () => {
    return (
      <footer>
        <div className="footer-container">
          {/* Our Company Section */}
          <div className="footer-section">
            <h3>Our Company</h3>
            <ul>
            <li>
                <Link to="/">Home</Link>
            </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/products?category=1">All Products</Link>
              </li>
              <li>
                <Link to="/catalogue">Catalogue</Link>
              </li>
              <li>
                <Link to="/calculator">Calculator</Link>
              </li>
              <li>
                <Link to="/dealer-info">Dealer Info</Link>
              </li>
              <li>
                <Link to="/contactus">Contact US</Link>
              </li>
              <li style={{ color:"white"}}>Stay connected with us on social media</li>
              <div className="social-icons">
              {/* Instagram Icon */}
              <a 
                href="https://www.instagram.com/aultra_paints/" 
                className="social-icon" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ cursor: 'pointer', display: 'inline-block' }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 48 48" style={{ pointerEvents: 'none' }}>
                  <radialGradient id="instagramGradient" cx="19.38" cy="42.035" r="44.899" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#fd5"></stop>
                    <stop offset=".328" stopColor="#ff543f"></stop>
                    <stop offset=".348" stopColor="#fc5245"></stop>
                    <stop offset=".504" stopColor="#e64771"></stop>
                    <stop offset=".643" stopColor="#d53e91"></stop>
                    <stop offset=".761" stopColor="#cc39a4"></stop>
                    <stop offset=".841" stopColor="#c837ab"></stop>
                  </radialGradient>
                  <path fill="url(#instagramGradient)" d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20
                    c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20
                    C42.014,38.383,38.417,41.986,34.017,41.99z"></path>
                  <radialGradient id="instagramInner" cx="11.786" cy="5.54" r="29.813" gradientTransform="matrix(1 0 0 .6663 0 1.849)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#4168c9"></stop>
                    <stop offset=".999" stopColor="#4168c9" stopOpacity="0"></stop>
                  </radialGradient>
                  <path fill="url(#instagramInner)" d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20
                    c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20
                    C42.014,38.383,38.417,41.986,34.017,41.99z"></path>
                  <path fill="#fff" d="M24,31c-3.859,0-7-3.14-7-7s3.141-7,7-7s7,3.14,7,7S27.859,31,24,31z M24,19c-2.757,0-5,2.243-5,5
                    s2.243,5,5,5s5-2.243,5-5S26.757,19,24,19z"></path>
                  <circle cx="31.5" cy="16.5" r="1.5" fill="#fff"></circle>
                  <path fill="#fff" d="M30,37H18c-3.859,0-7-3.14-7-7V18c0-3.86,3.141-7,7-7h12c3.859,0,7,3.14,7,7v12
                    C37,33.86,33.859,37,30,37z M18,13c-2.757,0-5,2.243-5,5v12c0,2.757,2.243,5,5,5h12c2.757,0,5-2.243,5-5V18c0-2.757-2.243-5-5-5H18z"></path>
                </svg>
              </a>

              {/* YouTube Icon */}
              <a 
                href="https://www.youtube.com/channel/UCaI-Nq-IcHJFDVwXZG4ybCQ" 
                className="social-icon" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ cursor: 'pointer', display: 'inline-block' }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 48 48" style={{ pointerEvents: 'none' }}>
                  <path fill="#FF3D00" d="M43.2,33.9c-0.4,2.1-2.1,3.7-4.2,4c-3.3,0.5-8.8,1.1-15,1.1c-6.1,0-11.6-0.6-15-1.1
                    c-2.1-0.3-3.8-1.9-4.2-4C4.4,31.6,4,28.2,4,24c0-4.2,0.4-7.6,0.8-9.9c0.4-2.1,2.1-3.7,4.2-4C12.3,9.6,17.8,9,24,9
                    c6.2,0,11.6,0.6,15,1.1c2.1,0.3,3.8,1.9,4.2,4c0.4,2.3,0.9,5.7,0.9,9.9C44,28.2,43.6,31.6,43.2,33.9z">
                  </path>
                  <path fill="#FFF" d="M20 31L20 17 32 24z"></path>
                </svg>
              </a>

              {/* Facebook Icon */}
              <a 
                href="https://www.facebook.com/share/1MF6C4ynwQ/?mibextid=wwXIfr" 
                className="social-icon" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ cursor: 'pointer', display: 'inline-block' }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 48 48" style={{ pointerEvents: 'none' }}>
                  <linearGradient id="facebookGradient" x1="9.993" x2="40.615" y1="9.993" y2="40.615" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#2aa4f4"></stop>
                    <stop offset="1" stopColor="#007ad9"></stop>
                  </linearGradient>
                  <path fill="url(#facebookGradient)" d="M24,4C12.954,4,4,12.954,4,24s8.954,20,20,20s20-8.954,20-20S35.046,4,24,4z"></path>
                  <path fill="#fff" d="M26.707,29.301h5.176l0.813-5.258h-5.989v-2.874c0-2.184,0.714-4.121,2.757-4.121h3.283V12.46
                    c-0.577-0.078-1.797-0.248-4.102-0.248c-4.814,0-7.636,2.542-7.636,8.334v3.498H16.06v5.258h4.948v14.452
                    C21.988,43.9,22.981,44,24,44c0.921,0,1.82-0.084,2.707-0.204V29.301z"></path>
                </svg>
              </a>
              </div>
            </ul>
          </div>
  
          {/* Contact Us Section */}
          <div className="footer-section">
            <h3>Contact Us</h3>
            <ul>
            <li>
              <a href="https://maps.app.goo.gl/ZXrQvkJw6KBsUxuU9" target="_blank" rel="noopener noreferrer">
                <i className="fas fa-map-marker-alt"></i>4TH FLOOR, 5-9-265/1A/NR SY NO 199/F, PLOT NO 14, PRASHANTHI NAGAR, RAJEEV GANDHI NAGAR, KUKATPALLY, HYDERABAD - 500072
              </a>
            </li>
            <li>
              <a href="tel:+914042469999">
                <i className="fas fa-phone-alt"></i> 040 4246 9999
              </a>
            </li>
            <li>
              <a href="mailto:aultratek@yahoo.co.in">
                <i className="fas fa-envelope"></i> aultratek@yahoo.co.in
              </a>
            </li>
            <li>
              <a href="mailto:info@aultrapaints.com">
                <i className="fas fa-envelope-open-text"></i> info@aultrapaints.com
              </a>
            </li>
           
            </ul>
          </div>

          {/* Painted with Precision Section */}
          <div className="footer-section painted-precision-section">
            <h3>PAINTED WITH PRECISION BY</h3>
            <div className="logo-container">
              <a 
                href="https://www.kliqontech.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ cursor: 'pointer', display: 'inline-block' }}
              >
                <img 
                  src={kliqon}
                  alt="Kliqon Tech Logo" 
                  className="footer-logo"
                />
              </a>
            </div>
          </div>
        </div>
  
        <div className="footer-bottom">
          <div className="footerimage-container1">
            <p className="copy">
              <span style={{ color: "#ff4500" }}>&copy; 2025 Aultrapaints. All rights reserved.</span>
            </p>
          </div>
        </div>
      </footer>
    );
  };
  
  export default Footer;